import * as React from "react";
// @ts-ignore
import { Graph } from "react-d3-graph";
import { useKruskal } from "./useKruskal";
import { colorTheme } from "../config";
var graphConfig = {
    linkHighlightBehavior: true,
    automaticRearrangeAfterDropNode: true,
    staticGraph: true,
    width: "100%",
    height: 350,
    node: {
        size: 1024,
        fontSize: 16,
        highlightFontSize: 16,
        labelPosition: "center",
        labelProperty: "label",
        strokeWidth: 8,
    },
    link: {
        strokeWidth: 16,
        highlightColor: colorTheme.primary.DEFAULT,
        fontSize: 16,
        labelProperty: "label",
        renderLabel: true,
        labelPosition: "center",
    },
    d3: {
        gravity: -300,
        alphaTarget: 0.75,
        linkLength: 100,
    },
};
export default function KruskalComponent() {
    var _a = useKruskal(), graphData = _a[0], clickLink = _a[1], reset = _a[2], error = _a[3], solved = _a[4], chancesLeft = _a[5], gameOver = _a[6];
    return (React.createElement("div", { className: "w-full p-4 h-3/6 flex flex-col gap-4" },
        React.createElement("div", { className: "w-full text-center text-3xl" }, "Kruskal Algorithm"),
        React.createElement("div", { className: "w-full text-left" },
            React.createElement("div", { className: "w-full text-xl font-medium" }, "How to use this tool?"),
            "Click the connections between the nodes in the order of kruskals algorithm. You can make 3 mistakes.",
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("span", { className: "bg-primary font-bold ml-4" }, "Dark green"),
            " indicates visited Nodes and Links.",
            React.createElement("br", null),
            React.createElement("span", { className: "bg-primary-lightest font-bold ml-4" }, "Light green"),
            " ",
            "indicates not visited Nodes and Links.",
            React.createElement("br", null),
            React.createElement("span", { className: "bg-error font-bold ml-4" }, "Red"),
            " indicates mistakes.",
            React.createElement("br", null)),
        gameOver ? (React.createElement("div", { className: "w-full p-8 border-8 border-red-300 rounded-lg text-red-800 font-bold" },
            "No more chances left. Reset (Reason: ",
            error,
            ")")) : (React.createElement("div", { className: "text-center" },
            "You have ",
            chancesLeft,
            " mistakes left.")),
        React.createElement(Graph, { className: "flex-grow", id: "graph-id" // id is mandatory
            , data: graphData.getComponentData(), config: graphConfig, onClickNode: function (link) {
                console.log(link);
            }, onClickLink: clickLink }),
        !gameOver && error ? (React.createElement("div", { className: "w-full p-8 border-8 border-red-300 rounded-lg text-red-800 font-bold" }, error)) : null,
        solved ? (React.createElement("div", { className: "w-full p-8 border-8 border-primary rounded-lg text-primary font-bold" }, "Solved! Congratulations!")) : null,
        React.createElement("div", { className: "flex flex-row flex-end justify-end gap-3" },
            React.createElement("button", { className: "bg-warning rounded px-3 py-2 w-2/12 ", onClick: function () {
                    window.location.reload();
                } }, "Reset"))));
}
